import {
  VIEW_SCREEN,
} from './types';

export const viewScreen = screenName => ({
  type: VIEW_SCREEN,
  screenName,
});
